import axios from "../http.js";

const api = {
  getPreAndProdVersion: (data) =>
    axios.get(`/module/getMobilePreAndProdVersion`, data),
  getMobileDevOrUatVersionList: (data) =>
    axios.get("/module/getMobileDevOrUatVersionList", data),
  getAppVersionList: (params) =>
    axios.get("/application/getByAppIdInH5", params),
  getRealBuildAppId: (params) =>
    axios.get(`/application/getRealBuildAppId`, params),
  getWxConfig: (params) =>
    axios.get(`https://uath5.xsyxsc.cn/api/auth/auth/sign`, params),
  getApplicationInfo: (data) =>
    axios.get("/appVersion/getApplicationInfo", data),
};
export default api;
